import {Box, Typography} from '@mui/material';
import {useMemo} from 'react';
import {SupportedDashboardActionTypes, WebsiteStructure} from '../../../api/models';
import {useEventBatching} from '../../../api/events';
import {useNavigate} from 'react-router-dom';

interface ActionTypeProps {
    actionType: SupportedDashboardActionTypes;
}

const getTitleFromActionType = (actionType: SupportedDashboardActionTypes): string | null => {
    switch (actionType) {
        case 'share':
            return 'Share';
        case 'orders-dashboard':
            return 'Orders Dashboard';
        case 'payments-dashboard':
            return 'Payments Dashboard';
        case 'delete':
        default:
            return null;
    }
};

export const DashboardActionItem = ({
    actionType,
    websiteStructure,
}: ActionTypeProps & {websiteStructure: WebsiteStructure}) => {
    const {trackEvent} = useEventBatching();
    const navigateTo = useNavigate();

    const title = useMemo(() => {
        return getTitleFromActionType(actionType);
    }, [actionType]);
    const subTitle = useMemo(() => {
        switch (actionType) {
            case 'share':
                const subDomain = websiteStructure.subDomain;
                const websiteUrl = `https://${subDomain}.socialmart.com`;
                return websiteUrl;
            case 'orders-dashboard':
                return 'Manage orders';
            case 'payments-dashboard':
                return 'Manage UPI details';
            case 'delete':
            default:
                return null;
        }
    }, [actionType]);

    const shareButtonFN = async () => {
        const subDomain = websiteStructure.subDomain;
        const websiteUrl = `https://${subDomain}.socialmart.com`;
        if (navigator.share) {
            const shareData = {
                title: 'My website',
                text: 'Hey, check out my online store created with SocialMart!',
                url: websiteUrl,
            };

            navigator
                .share(shareData)
                .then(() => console.log('Successful share'))
                .catch((error) => {
                    console.log('Error sharing:', error);
                    trackEvent({
                        eventName: 'Share button ',
                        props: {
                            errorMessage: error.toString(),
                        },
                    });
                });
        } else {
            try {
                await navigator.clipboard.writeText(websiteUrl);
                alert('Website link copied');
            } catch (error) {}
        }
    };

    const dashboardFn = () => {
        navigateTo('/orders/dashboard');
    };

    const dashboardFnPayments = () => {
        navigateTo('/payments/dashboard');
    }

    if (title === '') {
        return <></>;
    } else {
        return (
            <div
                onClick={() => {
                    switch (actionType) {
                        case 'share':
                            shareButtonFN();
                            break;
                        case 'delete':
                            break;
                        case 'orders-dashboard':
                            dashboardFn();
                            break;
                        case 'payments-dashboard':
                            dashboardFnPayments();
                            break;
                    }
                }}
                style={{
                    paddingTop: 6,
                    cursor: 'pointer',
                }}>
                <Box>
                    <Typography
                        style={{
                            fontWeight: 400,
                            color: 'black',
                        }}
                        variant='body1'
                        noWrap
                        component='div'>
                        {title}
                    </Typography>
                    {subTitle ? (
                        <Typography
                            style={{
                                fontWeight: 400,
                                color: 'black',
                            }}
                            variant='caption'
                            noWrap
                            component='div'>
                            {subTitle}
                        </Typography>
                    ) : (
                        <></>
                    )}
                </Box>
            </div>
        );
    }
};
